import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-input',
  templateUrl: './toggle-input.component.html',
  styleUrl: './toggle-input.component.scss'
})
export class ToggleInputComponent {
  private static idSequence = 0;

  /** Unique per instance — avoids duplicate id="flexSwitchChecked" breaking label clicks. */
  readonly switchId = `app-toggle-input-${++ToggleInputComponent.idSequence}`;

  @Input() checked = false;
  @Input() disabled = false;
  @Input() label: string;

  @Output() checkedChange = new EventEmitter<boolean>();

  onSwitchChange(event: Event): void {
    if (this.disabled) {
      return;
    }
    const input = event.target as HTMLInputElement;
    this.checkedChange.emit(input.checked);
  }
}
